export default {
      id: "cushion_all-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#cushion_all",
      toString: function () {
        return this.url;
      }
    }